/* eslint-disable */
import React from 'react';
import ReactDOM from 'react-dom';
import _get from 'lodash/get';
import _size from 'lodash/size';
import _findIndex from 'lodash/findIndex';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import TextField from '@mui/material/TextField';
import { connect } from 'react-redux';
import { readCookie } from '../../../../src/utils/Cookie';
import {
  addAddress,
  editAddress,
  postalCodeFetch,
  setPinCode,
  setPostalCode,
  resetPostalData,
  setDelivery,
  setCheckedAddress
} from '../../actions/addressBook';
import { hideModal } from '../../../actions/modal';
import {
  validateMobile,
  validateUsername,
  validatePincode,
  validateASCIIChars,
  validateFirstName,
  validateOthersAddressName
} from './../../../utils/inputValidator';
import { changeAddressSelectionOnCart, getCart } from '../../../cart/actions/cart';
import { isServerRendering } from '../../../utils/pageInfo.js';
import { fetchCartItemsEDDFromClient } from '../../../edd/actions/index.js';
import cleverTapPushEvent from '../../../modules/ajio-util/cleverTap/eventUtils';
import CLEVERTAP_EVENT_NAMES from '../../../modules/ajio-util/cleverTap/eventConstants';
import Input from '../../../refresh/molecules/Input';
import Icon from '../../../refresh/atoms/Icon';
import Text from '../../../refresh/atoms/Text';
import { gtmEventPush, gtmPagePush } from '../../../modules/ga/GTMdatalayer';
import { getDecodedString, getEncodedString } from '../../../modules/ajio-util/stringDecoder';
import FloatingInput from '../../../userauth/components/floating-input';
import { getLuxeFlags } from '../../../Flags/selectors';
import { getCurrentStore } from '../../../refresh/selectors/metaData';
import screen from '../../../refresh/constants/pageType.constant';
import readAloudFormErrors from '../../../utils/accessibility';
import { getGSTFlag } from '../../../refresh/selectors/featureFlagsSelector';

const userId = decodeURIComponent(readCookie('U')) || '';
const style = Object.freeze({
  fontSize: '1.8rem',
  fontWeight: 'bold'
});
const styles = {
  floatingLabelFocusStyle: {
    fontSize: '12px',
    left: '1px'
  },
  inputStyle: {
    fontSize: '14px',
    height: '60px',
    paddingBottom: '8px'
  },
  textAreaStyle: {
    fontSize: '14px',
    paddingBottom: '8px'
  },
  floatingLabelShrinkStyle: {
    lineHeight: '2px',
    left: '1px'
  },
  floatingLabelShrinkStyleTextArea: {
    left: '1px'
  }
};
const theme = createTheme({
  palette: {
    primary: {
      main: '#d4a048',
    }
  }
});
function isEDDRequired(url = '') {
  if (isServerRendering()) {
    return url.includes('/shipping') || url.includes('/addresses'); //have to check
  } else {
    const { location: { pathname = '' } = {} } = window;
    return pathname.includes('/shipping') || pathname.includes('/addresses');
  }
}
class AddAddressDesktop extends React.Component {
  constructor(props) {
    super(props);
    this.state = this.props;
    let profileName =
      (props.personalInfo && props.personalInfo.profile && props.personalInfo.profile.name) || '';
    let addressPoc = (this.state.address && this.state.address.addressPoc) || '';
    if (this.props.addrFormType !== 'Edit') {
      addressPoc = addressPoc || profileName;
    }
    const { firstName = '', lastName = '' } = this.props.address || {};
    if (this.props.addrFormType === 'Edit' && addressPoc === '') {
      if (firstName.length + lastName.length > 63) {
        addressPoc = firstName;
      } else {
        addressPoc = firstName.trim() + ' ' + lastName.trim();
      }
    }
    if (this.props.gstBusinessName) {
      addressPoc = this.props.gstBusinessName;
    }
    (this.address = {
      ...this.state.address,
      phone:
        (this.state.address && this.state.address.phone) ||
        readCookie('MN') ||
        props.personalInfo.profile.mobileNumber,
      addressPoc
    }),
      (this.addAddressSubmit = this.addAddressSubmit.bind(this));
    this.state = {
      ...this.state,
      address: this.address,
      errAddressPoc: '',
      errLandmark: '',
      errLastName: '',
      errMob: '',
      errPinCode: '',
      errCityDistrict: '',
      errMobileNum: '',
      errAltMobNum: '',
      errAddressLine1: '',
      errAddressLine2: '',
      defaultBoxChecked: false,
      addressLine3: '',
      errState: '',
      errCustomAddress: ''
    };
    this._saveAddressCallback = this.saveAddressCallback.bind(this);
  }
  saveAddressCallback(addresses = []) {
    const { address = {} } = this.state;
    let { defaultAddress = '' } = address;
    let {
      addrFormType,
      isPageType,
      setCheckedAddress,
      callback,
      entryNumber,
      enableGST = false,
      device = '',
      disableCartUpdate = false
    } = this.props;

    const getSelectedAddedAddress = () => {
      const fallbackIndex = _size(addresses) === 1 || defaultAddress ? 0 : 1;
      const fallbackAddress = _get(addresses, [fallbackIndex], {});
      const normalizedLine1 = `${address?.line1 || ''}`.trim().toLowerCase();
      const normalizedPostalCode = `${address?.postalCode || ''}`.trim();
      const normalizedPhone = `${address?.phone || ''}`.trim();

      const matchedAddress = addresses.find(item => {
        const itemLine1 = `${item?.line1 || ''}`.trim().toLowerCase();
        const itemPostalCode = `${item?.postalCode || ''}`.trim();
        const itemPhone = `${item?.phone || ''}`.trim();
        return (
          itemLine1 === normalizedLine1 &&
          itemPostalCode === normalizedPostalCode &&
          itemPhone === normalizedPhone
        );
      });

      return matchedAddress || fallbackAddress || {};
    };

    if (isPageType == 'shipping') {
      let selectedAddressObj = {};
      if (addrFormType === 'Edit') {
        const indexOfEditedAddress = _findIndex(addresses, ['id', entryNumber]);
        selectedAddressObj = _get(addresses, [indexOfEditedAddress], {});
        setCheckedAddress(
          entryNumber,
          selectedAddressObj?.postalCode,
          indexOfEditedAddress
        );
      } else {
        selectedAddressObj = getSelectedAddedAddress();
        const selectedIndex = _findIndex(addresses, ['id', selectedAddressObj?.id]);
        const { id, postalCode } = selectedAddressObj;
        if (selectedIndex >= 0 && id && postalCode) {
          setCheckedAddress(id, postalCode, selectedIndex);
        }
      }
      if (enableGST && isPageType == 'shipping' && device !== 'mobile' && !disableCartUpdate) {
        const { id, postalCode } = selectedAddressObj;
        if (id && postalCode) {
          this.props.updateAddressOnCart({ addressId: id, pincode: postalCode });
        }
      }
    }
    if (this.props.callback) {
      this.props.callback(addresses, addrFormType);
    }
    const { location: { search = '' } = {} } = window || {};
    if (search.includes('shipping')) {
      if (this.props.addrFormType !== 'Edit') {
        window.location = '/shipping';
      }
    }
  }
  componentWillMount() {
    this.props.resetPostalData();
  }
  componentDidMount() {
    let { address = {}, addrFormType = '', isPageType = '' } = this.props;
    let { line1 = '', town = '', defaultAddress = 'false' } = address;
    const addressLine3 = town ? `${line1}, ${town}` : line1;
    this.setState({ addressLine3 });
    gtmEventPush({
      event: 'form_initiate',
      form_name: addrFormType == 'Edit' ? 'Edit address' : 'Add address'
    });
    const { addressSelection: { pageType = '' } = {} } = screen;
    gtmPagePush(
      `${addrFormType == 'Edit' ? 'update' : 'create'} address screen - shipping`,
      pageType,
      window.__ENV__ || '',
      {
        store: this.props.newDesignLuxe ? 'luxe' : 'AJIO',
        make_as_default: defaultAddress
      }
    );
  }
  handleInputChange(newPartialInput) {
    let inputObjKey = Object.keys(newPartialInput)[0];
    let inputObjVal = Object.values(newPartialInput)[0];
    if (inputObjKey == 'addressPoc') {
      if (validateFirstName(inputObjVal)) {
        this.setState({
          errAddressPoc: ''
        });
      } else {
        this.setState({
          errAddressPoc: 'Accepts only alphabets & spaces between words.'
        });
      }
    }
    // if (inputObjKey == "firstName") {
    //   if (validateFirstName(inputObjVal)) {
    //     this.setState({
    //       errFirstName: ""
    //     })
    //   } else {
    //     this.setState({
    //       errFirstName: "Accepts only alphabets & spaces between words."
    //     })
    //   }
    // }
    else if (inputObjKey == 'landmark') {
      if (validateFirstName(inputObjVal)) {
        this.setState({
          errLandmark: ''
        });
      } else {
        this.setState({
          errLandmark: 'Accepts only alphabets & spaces between words.'
        });
      }
    }
    // else if (inputObjKey == "lastName") {
    //   if (validateUsername(inputObjVal)) {
    //     this.setState({
    //       errLastName: ""
    //     })
    //   }
    //   else {
    //     this.setState({
    //       errLastName: "Accepts only alphabets & spaces between words."
    //     })
    //   }
    // }
    else if (inputObjKey == 'postalCode') {
      if (validatePincode(inputObjVal)) {
        this.setState({
          errPinCode: ''
        });
      } else {
        this.setState({
          errPinCode: 'Enter valid Pincode'
        });
      }
    } else if (inputObjKey == 'line1') {
      this.setState({ addressLine3: inputObjVal });
      if (inputObjVal !== '') {
        this.setState({
          errAddressLine1: ''
        });
      } else {
        this.setState({
          errAddressLine1: 'Enter valid  Flat no/Building Name'
        });
      }
    } else if (inputObjKey == 'line2') {
      if (inputObjVal !== '') {
        this.setState({
          errAddressLine2: ''
        });
      } else {
        this.setState({
          errAddressLine2: 'Enter valid Locality / Area / Street'
        });
      }
    } else if (inputObjKey == 'district') {
      if (validateUsername(inputObjVal)) {
        this.setState({
          errCityDistrict: ''
        });
      } else {
        this.setState({
          errCityDistrict: 'Please enter a valid city/district.'
        });
      }
    } else if (inputObjKey == 'phone') {
      if (validateMobile(inputObjVal)) {
        this.setState({
          errMobileNum: ''
        });
      } else {
        this.setState({
          errMobileNum: 'Please enter a valid 10 digit mobile number.'
        });
      }
    } else if (inputObjKey == 'altMobNum') {
      if (validateMobile(inputObjVal)) {
        this.setState({
          errAltMobNum: ''
        });
      } else {
        this.setState({
          errAltMobNum: 'Please enter a valid 10 digit mobile number.'
        });
      }
    }
    if (inputObjKey == 'customAddressType') {
      if (validateOthersAddressName(inputObjVal)) {
        this.setState({
          errCustomAddress: ''
        });
      } else {
        this.setState({
          errCustomAddress: 'Accepts only alphabets & spaces between words.'
        });
      }
    }
    this.setState(state => ({
      ...state,
      address: {
        ...state.address,
        ...newPartialInput
      }
    }));
  }
  handleResetButton(event, initialaddresss = {}) {
    event.stopPropagation();
    event.preventDefault();
    const { addrFormType, handleGtmEvent } = this.props;
    let { line1 = '', town = '' } = initialaddresss;
    const addressLine3 = town ? `${line1}, ${town}` : line1;
    // if(this.props.addrFormType === 'Add' ){
    // let {phone } = this.state.address;
    // initialaddresss.phone = phone;
    // let {addressPoc } = this.state.address;
    //   initialaddresss.addressPoc = addressPoc;
    // }
    this.props.resetPostalData();
    this.setState(state => ({
      ...state,
      address: this.address,
      addressLine3
    }));

    if (addrFormType === 'Edit') {
      this.props.handleGtmEvent('edit_reset', 'edit reset', 'Update');
    } else if (addrFormType === 'Add') {
      this.props.handleGtmEvent('add_reset', 'add reset', 'Create');
    }
  }
  handlePostalCode(newPartialInput) {
    //Here Code to get the API Call
    let { postalCode = '' } = newPartialInput;
    if (postalCode.length == 6) {
      this.props.getlocationFromPostalCode(newPartialInput);
    }
    this.handleInputChange(newPartialInput);
  }
  checkMandatoryFields = (
    postalCode,
    addressPoc,
    line1,
    line2,
    district,
    phone,
    state,
    landmark
  ) => {
    if (postalCode == '') {
      this.setState({
        errPinCode: 'Enter valid Pincode'
      });
    }
    if (addressPoc == '') {
      this.setState({
        errAddressPoc: 'Enter valid  Name'
      });
    }
    // if (firstName == "") {
    //   this.setState({
    //     errFirstName: "Enter valid First Name"
    //   })
    // }
    // if (lastName == "") {
    //   this.setState({
    //     errLastName: "Enter valid Last Name"
    //   })
    // }
    if (validateASCIIChars(line1).trim().length === 0) {
      this.setState({
        errAddressLine1: 'Enter valid  Flat no/Building Name'
      });
    }
    if (validateASCIIChars(line2).trim().length === 0) {
      this.setState({
        errAddressLine2: 'Enter valid Locality / Area / Street'
      });
    }
    if (district == '') {
      this.setState({
        errCityDistrict: 'Please enter a City/District'
      });
    }
    if (state == '') {
      this.setState({
        errState: 'Please enter a state'
      });
    }
    let isNotValidMobileNum =
      phone == '' || isNaN(phone) || phone.indexOf(' ') != -1 || phone.length !== 10;
    if (isNotValidMobileNum) {
      this.setState({
        errMobileNum: 'Please enter a valid 10 digit mobile number.'
      });
    }
    if (this.props.newDesignLuxe) {
      if (landmark == '') {
        this.setState({
          errLandmark: 'Please enter a landmark'
        });
      }
    }
    if (
      postalCode == '' ||
      addressPoc == '' ||
      validateASCIIChars(line1).trim().length === 0 ||
      validateASCIIChars(line2).trim().length === 0 ||
      district == '' ||
      state == '' ||
      isNotValidMobileNum ||
      this.props.newDesignLuxe
        ? landmark == ''
        : null
    ) {
      return false;
    } else {
      return true;
    }
  };
  scrollToError = () => {
    this.errorMessages.scrollIntoView({ behavior: 'smooth' });
  };
  addAddressSubmit = async (
    event,
    postalCode,
    addressPoc,
    line1,
    district,
    phone,
    line2,
    town,
    landmark,
    altMobNum,
    defaultAddress,
    state,
    selectedAddressType,
    customAddressType
  ) => {
    event.preventDefault();
    const {
      entryNumber,
      addrFormType,
      isPageType = '',
      editAddressCheckout,
      editAddress,
      setCheckedAddress,
      fetchCartItemsEDDFromClient,
      setDelivery,
      addAddress,
      enableGST = false,
      isBillingAddressFlow = false
    } = this.props;
    cleverTapPushEvent({
      eventName: CLEVERTAP_EVENT_NAMES.Address_Added,
      eventObj: {
        type: selectedAddressType,
        pinCode: postalCode,
        city: district,
        state: state,
        user_id: userId != 'null' ? userId : 'anonymous',
        platform: 'MSITE'
      }
    });
    gtmEventPush({
      event: 'form_submit',
      form_name: addrFormType == 'Edit' ? 'Edit address' : 'Add address'
    });
    const addressList = _get(this.props, 'addressBook.addresses', []);
    const mandatoryFieldsFilled = this.checkMandatoryFields(
      postalCode,
      addressPoc,
      line1,
      line2,
      district,
      phone,
      state,
      landmark
    );
    const formData = document.getElementById('addAddressForm')
      ? document.getElementById('addAddressForm').elements
      : [];
    let addAddrData = {};
    for (let idx = 0, len = formData.length; idx < len; idx++) {
      let { name = '', value = '', checked = false } = formData[idx] || {};
      if (name) {
        if (name == 'defaultAddress') {
          addAddrData[name] = checked;
        } else {
          if (name === 'selectedAddressType') {
            if (checked) {
              const validValue = validateASCIIChars(value);
              addAddrData[name] = getEncodedString(validValue.trim());
            }
          } else {
            const validValue = validateASCIIChars(value);
            addAddrData[name] = getEncodedString(validValue.trim());
          }
        }
      }
    }
    if (this.props.gstBusinessName) {
      const { firstName = '', lastName = '' } = this.props.personalInfo?.profile || {};
      addAddrData.addressPoc = `${firstName.trim()} ${lastName.trim()}`;
    }
    if (enableGST && isPageType == 'shipping' && !isBillingAddressFlow) {
      addAddrData.defaultAddress = true;
    }
    //Dispactching an action to addAddress
    if (mandatoryFieldsFilled) {
      if (addrFormType == 'Edit') {
        addAddrData['id'] = entryNumber;
        if (isPageType == 'checkout') {
          editAddressCheckout(addAddrData);
        } else {
          editAddress(addAddrData, this._saveAddressCallback);
          if (isEDDRequired()) {
            fetchCartItemsEDDFromClient(addAddrData.postalCode).then(response => {
              if (response.status.statusCode === 0) {
                const { pinCode, servicability, codEligible } = response;
                if (!servicability) {
                  window.ga &&
                    window.ga('send', {
                      hitType: 'event',
                      eventCategory: 'buttonTap',
                      eventAction: 'EDD on Shipping Page',
                      eventLabel: `Proceed to payment disabled - ${pinCode}`
                    });
                }
              }
            });
          }
          const { location: { pathname = '', search = '' } = {} } = window || {};
          const isReferrerShippingPage =
            pathname.includes('/my-account/address-book') && search.includes('shipping');
          if (isReferrerShippingPage) {
            setDelivery(this.props.entryNumber);
          }
        }
        this.props.setPinCode(postalCode);
      } else {
        addAddress(addAddrData, this._saveAddressCallback);
      }
    } else {
      this.scrollToError();
    }
    // window.location('/address-book');
  };
  render() {
    //Setting the Value from the Props
    const { address = {}, addrFormType = 'Add', modalName = '', addressLine3 = '' } = this.state;
    let { address: initialaddresss = {}, device = '' } = this.props;
    let {
      addressBook: {
        postalData: { district: distNew = '', invalidpostalcode = false, state: stateNew = '' } = {}
      } = {},
      isPageType = ''
    } = this.props;
    let {
      id = '',
      firstName = '',
      lastName = '',
      addressPoc = '',
      line1 = '',
      line2 = '',
      line3 = '',
      landmark = '',
      town = '',
      district = '',
      state = '',
      postalCode = '',
      phone = '',
      altMobNum = '',
      codEligible = '',
      exchangeService = '',
      selectedAddressType = 'HOME',
      customAddressType = '',
      defaultAddress = '',
      country = {}
    } = address;
    customAddressType = getDecodedString(customAddressType);
    let { isocode = 'IN' } = country;
    let cityDistrict = distNew ? distNew : district;
    cityDistrict = invalidpostalcode ? '' : cityDistrict;
    let newState = stateNew ? stateNew : state;
    newState = invalidpostalcode ? '' : newState;
    return (
      <ThemeProvider theme={theme}>
        <form
          className="add-address-form"
          id="addAddressForm"
          onSubmit={e => {
            this.addAddressSubmit(
              e,
              postalCode,
              addressPoc,
              line1,
              cityDistrict,
              phone,
              line2,
              town,
              landmark,
              altMobNum,
              defaultAddress,
              newState,
              selectedAddressType,
              customAddressType
            );

            if (addrFormType === 'Edit') {
              this.props.handleGtmEvent('edit_save', 'edit save', 'Update');
            } else if (addrFormType === 'Add') {
              this.props.handleGtmEvent('add_new_save', 'add new save', 'Create');
            }
            readAloudFormErrors(".address-error-msg");
            readAloudFormErrors(".error-msg");
          }}
        >
          <div className="add-address-form-container">
            <div className="addNewAddressText">
              {this.props.addrFormType == 'Edit' ? 'Edit Address Details' : 'Add new address'}
            </div>
            <div>
              <FloatingInput
                type="text"
                value={addressPoc}
                onChange={this.props.gstBusinessName ? undefined : e => this.handleInputChange({ addressPoc: e.target.value })}
                name="addressPoc"
                size="32"
                maxLength="64"
                fullWidth
                autoComplete={'name'}
                floatingText="Name"
                placeholder="  "
                error={this.state.errAddressPoc}
                readOnly={!!this.props.gstBusinessName}
              />
              {this.props.newDesignLuxe ? (
                <div
                  style={{ textAlign: 'left' }}
                  ref={el => {
                    this.errorMessages = el;
                  }}
                  id="error-msg"
                  className="error-msg"
                  aria-live='polite'
                >
                  {this.state.errMobileNum}
                </div>
              ) : (
                <span id="error-msg" className="error-msg" aria-live='polite'>
                  {this.state.errAddressPoc}
                </span>
              )}
            </div>
            {/*  <div className="mobaddadddr-input">                
                 <TextField
                  type="text"
                  value={addressPoc}
                  onChange={e => this.handleInputChange({ addressPoc: e.target.value })}
                  name="addressPoc"
                  size="32"
                  maxLength="64"
                  fullWidth
                  autoComplete={'Off'}
                  floatingLabelText="Name*"
                  style={styles.inputStyle}
                  floatingLabelFocusStyle={styles.floatingLabelFocusStyle}
                  floatingLabelStyle={styles.floatingLabelShrinkStyle}
                />
                <span className="address-error-msg">{this.state.errAddressPoc}</span>
    </div> */}
            <div>
              <FloatingInput
                value={phone}
                onChange={e => this.handleInputChange({ phone: e.target.value })}
                name="phone"
                size="32"
                maxLength="10"
                fullWidth
                autoComplete={'tel'}
                type="tel"
                floatingText="Mobile"
                placeholder="  "
                error={this.state.errMobileNum}
              />
            </div>
            <div
              style={this.props.newDesignLuxe ? { textAlign: 'left' } : null}
              ref={el => {
                this.errorMessages = el;
              }}
              id="error-msg"
              className="error-msg"
              aria-live='polite'
            >
              {this.state.errMobileNum}
            </div>
            {/* <div className="mobaddadddr-input">
                  <TextField
                  value={phone}
                  onChange={e => this.handleInputChange({ phone: e.target.value })}
                  name="phone"
                  size="32"
                  maxLength="10"
                  floatingLabelText="Mobile*"
                  fullWidth
                  autoComplete={'Off'}
                  style={styles.inputStyle}
                  floatingLabelFocusStyle={styles.floatingLabelFocusStyle}
                  floatingLabelStyle={styles.floatingLabelShrinkStyle}
                  type="tel" />
                  
                <div ref={(el) => { this.errorMessages = el; }} className="address-error-msg">{this.state.errMobileNum}</div>
</div> */}
            {this.props.newDesignLuxe ? (
              <div className={`${device === 'mobile' ? 'address-info-section' : ''}`}>
                <input type="hidden" name="country.isocode" value={isocode} />
                <div>
                  <FloatingInput
                    type="number"
                    value={postalCode}
                    onChange={e => this.handlePostalCode({ postalCode: e.target.value })}
                    name="postalCode"
                    size="32"
                    maxLength="6"
                    autoComplete={'postal-code'}
                    fullWidth
                    floatingText="Pin Code"
                    placeholder="  "
                    error={this.state.errPinCode}
                  />
                  {invalidpostalcode ? (
                    <div
                      style={this.props.newDesignLuxe ? { textAlign: 'left' } : null}
                      ref={el => {
                        this.errorMessages = el;
                      }}
                      id="error-msg"
                      className="error-msg"
                      aria-live='polite'
                    >
                      {' '}
                      Sorry, the pincode entered is either invalid or non serviceable{' '}
                    </div>
                  ) : (
                    <div
                      style={this.props.newDesignLuxe ? { textAlign: 'left' } : null}
                      ref={el => {
                        this.errorMessages = el;
                      }}
                      id="error-msg"
                      className="error-msg"
                      aria-live='polite'
                    >
                      {this.state.errPinCode}
                    </div>
                  )}
                </div>

                <div>
                  <FloatingInput
                    value={line2}
                    onChange={e => this.handleInputChange({ line2: e.target.value })}
                    name="line2"
                    multiLine={true}
                    size="32"
                    maxLength="200"
                    rows={1}
                    rowsMax="4"
                    autoComplete="address-line2"
                    fullWidth
                    type="text"
                    floatingText="Locality / Area / Street"
                    placeholder="  "
                    error={this.state.errAddressLine2}
                  />
                  <div
                    style={this.props.newDesignLuxe ? { textAlign: 'left' } : null}
                    ref={el => {
                      this.errorMessages = el;
                    }}
                    id="error-msg"
                    className="error-msg"
                    aria-live='polite'
                  >
                    {this.state.errAddressLine2}
                  </div>
                </div>

                <div>
                  <FloatingInput
                    value={addressLine3}
                    onChange={e => this.handleInputChange({ line1: e.target.value })}
                    name="line1"
                    size="32"
                    maxLength="30"
                    autoComplete="address-line1"
                    floatingText="Flat number / Building Name"
                    fullWidth
                    type="text"
                    placeholder="  "
                    error={this.state.errAddressLine1}
                  />
                  <div
                    style={this.props.newDesignLuxe ? { textAlign: 'left' } : null}
                    ref={el => {
                      this.errorMessages = el;
                    }}
                    id="error-msg"
                    className="error-msg"
                    aria-live='polite'
                  >
                    {this.state.errAddressLine1}
                  </div>
                </div>

                <div>
                  <FloatingInput
                    value={landmark}
                    onChange={e => this.handleInputChange({ landmark: e.target.value })}
                    name="landmark"
                    size="32"
                    maxLength="30"
                    autoComplete={'Off'}
                    floatingText="Landmark"
                    fullWidth
                    type="text"
                    placeholder="  "
                    error={this.state.errLandmark}
                  />
                  <div
                    style={this.props.newDesignLuxe ? { textAlign: 'left' } : null}
                    ref={el => {
                      this.errorMessages = el;
                    }}
                    id="error-msg"
                    className="error-msg"
                    aria-live='polite'
                  >
                    {this.state.errLandmark}
                  </div>
                </div>

                <div>
                  <FloatingInput
                    value={cityDistrict}
                    readOnly
                    onChange={e => this.handleInputChange({ district: e.target.value })}
                    name="district"
                    size="32"
                    maxLength="30"
                    autoComplete="address-level2"
                    floatingText="District/City"
                    fullWidth
                    type="text"
                    placeholder="  "
                    error={this.state.errCityDistrict}
                  />
                  {invalidpostalcode ? (
                    <div
                      style={{ textAlign: 'left' }}
                      id="error-msg"
                      className="address-error-msg error-msg"
                    >
                      {' '}
                      Please enter a City/District{' '}
                    </div>
                  ) : (
                    <div style={{ textAlign: 'left' }}>
                      {!cityDistrict && (
                        <span id="error-msg" className="address-error-msg error-msg">
                          {this.state.errCityDistrict}
                        </span>
                      )}
                    </div>
                  )}
                </div>

                <div>
                  <FloatingInput
                    value={newState}
                    readOnly
                    onChange={e => this.handleInputChange({ state: e.target.value })}
                    name="state"
                    size="32"
                    maxLength="30"
                    autoComplete="address-level1"
                    fullWidth
                    type="text"
                    floatingText="State"
                    placeholder="  "
                    error={this.state.errState}
                  />
                  <div
                    style={this.props.newDesignLuxe ? { textAlign: 'left' } : null}
                    ref={el => {
                      this.errorMessages = el;
                    }}
                    id="error-msg"
                    className="error-msg"
                    aria-live='polite'
                  >
                    {this.state.errState}
                  </div>
                </div>
              </div>
            ) : (
              <div className={`${device === 'mobile' ? 'address-info-section' : ''}`}>
                <input type="hidden" name="country.isocode" value={isocode} />
                <div>
                  <FloatingInput
                    type="tel"
                    value={postalCode}
                    onChange={e => this.handlePostalCode({ postalCode: e.target.value })}
                    name="postalCode"
                    size="32"
                    maxLength="6"
                      autoComplete={'postal-code'}
                    fullWidth
                    floatingText="Pin Code"
                    placeholder="  "
                    error={this.state.errPinCode}
                  />
                  {invalidpostalcode ? (
                    <span id="error-msg" className="error-msg" aria-live='polite'>
                      {' '}
                      Sorry, the pincode entered is either invalid or non serviceable{' '}
                    </span>
                  ) : (
                    <span id="error-msg" className="error-msg" aria-live='polite'>
                      {this.state.errPinCode}
                    </span>
                  )}
                </div>
                {/* <div className="mobaddadddr-input">
              <TextField
                type="tel"
                value={postalCode}
                onChange={e => this.handlePostalCode({ postalCode: e.target.value })}
                name="postalCode"
                size="32"
                maxLength="6"
                autoComplete={'Off'}
                floatingLabelText="Pin Code*"
                fullWidth
                style={styles.inputStyle}
                floatingLabelFocusStyle={styles.floatingLabelFocusStyle}
                floatingLabelStyle={styles.floatingLabelShrinkStyle}
              /> */}
                {/* invalidpostalcode ?
                <span className="address-error-msg"> Sorry, the pincode entered is either invalid or non serviceable </span> :
               <span className="address-error-msg">{this.state.errPinCode}</span> */}
                {/* </div> */}

                <div>
                  <FloatingInput
                    value={line2}
                    onChange={e => this.handleInputChange({ line2: e.target.value })}
                    name="line2"
                    multiLine={true}
                    size="32"
                    maxLength="200"
                    rows={1}
                    rowsMax="4"
                      autoComplete="address-line2"
                    fullWidth
                    type="text"
                    floatingText="Locality / Area / Street"
                    placeholder="  "
                    error={this.state.errAddressLine2}
                  />
                  <span id="error-msg" className="error-msg" aria-live='polite'>
                    {this.state.errAddressLine2}
                  </span>
                </div>
                {/* <div className="mobaddadddr-input">
              <TextField
                value={line2}
                onChange={e => this.handleInputChange({ line2: e.target.value })}
                name="line2"
                multiLine={true}
                size="32"
                maxLength="200"
                rows={1}
                rowsMax="4"
                autoComplete={'Off'}
                floatingLabelText="Locality / Area / Street*"
                style={styles.textAreaStyle}
                floatingLabelFocusStyle={styles.floatingLabelFocusStyle}
                floatingLabelStyle={styles.floatingLabelShrinkStyleTextArea}
                fullWidth
                type="text"
              />
                <span className="address-error-msg">{this.state.errAddressLine2}</span> 
            </div> */}

                <div>
                  <FloatingInput
                    value={addressLine3}
                    onChange={e => this.handleInputChange({ line1: e.target.value })}
                    name="line1"
                    size="32"
                    maxLength="30"
                      autoComplete="address-line1"
                    floatingText="Flat number / Building Name"
                    fullWidth
                    type="text"
                    placeholder="  "
                    error={this.state.errAddressLine1}
                  />
                  <span id="error-msg" className="error-msg" aria-live='polite'>
                    {this.state.errAddressLine1}
                  </span>
                </div>
                {/* <div className="mobaddadddr-input">
              <TextField
                value={addressLine3}
                onChange={e => this.handleInputChange({ line1: e.target.value })}
                name="line1"
                size="32"
                maxLength="30"
                autoComplete={'Off'}
                floatingLabelText="Flat number / Building Name*"
                fullWidth
                style={styles.inputStyle}
                floatingLabelFocusStyle={styles.floatingLabelFocusStyle}
                floatingLabelStyle={styles.floatingLabelShrinkStyle}
                type="text" />
              <span className="address-error-msg">{this.state.errAddressLine1}</span>
        </div> */}

                <div>
                  <FloatingInput
                    value={landmark}
                    onChange={e => this.handleInputChange({ landmark: e.target.value })}
                    name="landmark"
                    size="32"
                    maxLength="30"
                    autoComplete={'Off'}
                    floatingText="Landmark"
                    fullWidth
                    type="text"
                    placeholder="  "
                    error={this.state.errLandmark}
                  />
                  <span id="error-msg" className="error-msg" aria-live='polite'>
                    {this.state.errLandmark}
                  </span>
                </div>
                {/* <div className="mobaddadddr-input">
              <TextField
                value={landmark}
                onChange={e => this.handleInputChange({ landmark: e.target.value })}
                name="landmark"
                size="32"
                maxLength="30"
                autoComplete={'Off'}
                floatingLabelText="Landmark"
                fullWidth
                style={styles.inputStyle}
                floatingLabelFocusStyle={styles.floatingLabelFocusStyle}
                floatingLabelStyle={styles.floatingLabelShrinkStyle}
                type="text" />
              <span className="address-error-msg">{this.state.errLandmark}</span>
    </div> */}

                <div>
                  <FloatingInput
                    value={cityDistrict}
                    readOnly
                    onChange={e => this.handleInputChange({ district: e.target.value })}
                    name="district"
                    size="32"
                    maxLength="30"
                      autoComplete="address-level2"
                    floatingText="District/City"
                    fullWidth
                    type="text"
                    placeholder="  "
                    error={this.state.errCityDistrict}
                  />
                  {invalidpostalcode ? (
                    <span id="error-msg" className="error-msg" aria-live='polite'>
                      {' '}
                      Please enter a City/District{' '}
                    </span>
                  ) : (
                    <div>
                      {!cityDistrict && (
                        <span id="error-msg" className="address-error-msg error-msg">
                          {this.state.errCityDistrict}
                        </span>
                      )}
                    </div>
                  )}
                </div>
                {/* <div className="mobaddadddr-input">
              <TextField
                value={cityDistrict}
                readOnly
                onChange={e => this.handleInputChange({ district: e.target.value })}
                name="district"
                size="32"
                maxLength="30"
                autoComplete={'Off'}
                floatingLabelText="District/City*"
                fullWidth
                style={styles.inputStyle}
                floatingLabelFocusStyle={styles.floatingLabelFocusStyle}
                floatingLabelStyle={styles.floatingLabelShrinkStyle}
                type="text" />
              {invalidpostalcode ?
                <span className="address-error-msg"> Please enter a City/District </span> :
                <div>{!cityDistrict && <span className="address-error-msg">{this.state.errCityDistrict}</span>}</div>}
              </div> */}

                <div>
                  <FloatingInput
                    value={newState}
                    readOnly
                    onChange={e => this.handleInputChange({ state: e.target.value })}
                    name="state"
                    size="32"
                    maxLength="30"
                      autoComplete="address-level1"
                    fullWidth
                    type="text"
                    floatingText="State"
                    placeholder="  "
                    error={this.state.errState}
                  />
                  <span id="error-msg" className="error-msg" aria-live='polite'>
                    {this.state.errState}
                  </span>
                </div>
                {/* <div className="mobaddadddr-input">
              <TextField
                value={newState}
                readOnly
                onChange={e => this.handleInputChange({ state: e.target.value })}
                name="state"
                size="32"
                maxLength="30"
                autoComplete={'Off'}
                floatingLabelText="State*"
                style={styles.inputStyle}
                floatingLabelFocusStyle={styles.floatingLabelFocusStyle}
                floatingLabelStyle={styles.floatingLabelShrinkStyle}
                fullWidth
                type="text" />
              <span className="address-error-msg">{this.state.errState}</span>
            </div> */}
              </div>
            )}
            <div className="mobaddadddr-input typeOfAdd">
              <fieldset className="radio-group-fieldset">
                <legend className="sr-only">Address Type</legend>

              <p className="input-box radioButton">
                <div className="radioButton-header" aria-label='Address Type'>Address Type</div>
                <input
                  type="radio"
                  className="radioButton"
                  name="selectedAddressType"
                  checked={selectedAddressType === 'HOME'}
                  value="HOME"
                  //checked={selectedAddressType == "HOME" ? true : false}
                  onChange={e => this.handleInputChange({ selectedAddressType: 'HOME' })}
                  aria-label='Home'
                />
                <label className="radio-text" aria-label='Home'>Home</label>
                <input
                  type="radio"
                  className="radioButton"
                  name="selectedAddressType"
                  checked={selectedAddressType === 'WORK'}
                  value="WORK"
                  //checked={selectedAddressType == "WORK" ? true : false}
                  onChange={e => this.handleInputChange({ selectedAddressType: 'WORK' })}
                  aria-label='Work'
                />
                  <label className="radio-text" aria-label='Work'>Work</label>
                <input
                  type="radio"
                  className="radioButton"
                  name="selectedAddressType"
                  checked={selectedAddressType === 'OTHER'}
                  value="OTHER"
                  //checked={selectedAddressType == "OTHERS" ? true : false}
                  onChange={e => this.handleInputChange({ selectedAddressType: 'OTHER' })}
                  aria-label='Others'
                />
                <label className="radio-text" aria-label='Others'>Others</label>
              </p>
              </fieldset>
            </div>
            <div>
              <FloatingInput
                type="text"
                value={customAddressType}
                onChange={e => this.handleInputChange({ customAddressType: e.target.value })}
                name="customAddressType"
                size="32"
                maxLength="30"
                fullWidth
                autoComplete={'Off'}
                floatingText="Enter Address name"
                placeholder="  "
                error={this.state.errCustomAddress}
              />
              <span id="error-msg" className="error-msg" aria-live='polite'>
                {this.state.errCustomAddress}
              </span>
            </div>
            {/* <TextField
                  type="text"
                  value={customAddressType}
                  onChange={e => this.handleInputChange({ customAddressType: e.target.value })}
                  name="customAddressType"
                  size="32"
                  maxLength="30"
                  fullWidth
                  autoComplete={'Off'}
                  floatingLabelText="Enter Address name"
                  style={styles.inputStyle}
                  floatingLabelFocusStyle={styles.floatingLabelFocusStyle}
                  floatingLabelStyle={styles.floatingLabelShrinkStyle}
                />
                <span className="address-error-msg">{this.state.errCustomAddress}</span> */}
            {!this.props.enableGST && isPageType != 'checkout' && (
              <div
                style={this.props.newDesignLuxe ? { marginTop: '15px' } : null}
                className="mobaddaddr-default defaultAddressMsite"
              >
                <span>
                  <input
                    type="checkbox"
                    value={this.state.defaultAddress}
                    defaultChecked={defaultAddress}
                    name="defaultAddress"
                    checked={this.state.defaultAddress}
                    onClick={e => {
                      let newAdresss = Object.assign({}, this.state.address); //creating copy of object
                      newAdresss.defaultAddress = !this.state.address.defaultAddress; //updating value
                      this.setState({
                        defaultBoxChecked: !this.state.defaultBoxChecked,
                        address: newAdresss
                      });
                      defaultAddress = !defaultAddress;
                      //this.setState({defaultBoxChecked : !this.state.defaultBoxChecked})}
                    }}
                    aria-label='Make as default Address'
                  />
                  <label aria-label='Make as default Address'> Make as default Address</label>
                </span>
              </div>
            )}
          </div>
          <div className="mobaddaddr-type">
            <button
              onClick={e => this.handleResetButton(e, initialaddresss)}
              className="rilrtl-button button mobaddaddr-reset"
              id="deskResetBtn" aria-label='Reset'
            >
              <strong>Reset</strong>
            </button>
            <button type="submit" className="rilrtl-button button mobaddaddr-save" aria-label='Save'>
              <strong>Save</strong>
            </button>
          </div>
        </form>
      </ThemeProvider>
    );
  }
}
const mapStatetoProps = state => {
  const { addressBook = [], personalInfo = [], httpError = {} } = state;
  let { product = {}, request = {}, cartItem = [], cart = {}, order = {}, flags } = state;
  const { isDesktopThemeEnable } = getLuxeFlags(flags);
  const storeName = getCurrentStore(state);
  const newDesignLuxe = isDesktopThemeEnable === 'ON' && storeName === 'luxe';
  const enableGST = getGSTFlag(state);
  return {
    addressBook,
    personalInfo,
    httpError,
    newDesignLuxe,
    enableGST
  };
};
const mapDispatchToProps = dispatch => {
  return {
    addAddress: (formData, callback) => {
      dispatch(addAddress(formData, callback));
      dispatch(hideModal('address-add'));
    },
    editAddressCheckout: (formData, cb) => {
      dispatch(editAddress(formData, cb));
      dispatch(getCart({ isRequestOrginIsBrowser: true }));
      dispatch(hideModal('address-edit'));
    },
    editAddress: (formData, callback) => {
      dispatch(editAddress(formData, callback));
      dispatch(hideModal('address-edit'));
    },
    getlocationFromPostalCode: postalCodeObj => {
      dispatch(postalCodeFetch(postalCodeObj));
    },
    setPostalCode: (postalCodeData = {}) => {
      dispatch(setPostalCode(postalCodeData));
    },
    setPinCode: (pincode = '') => {
      dispatch(setPinCode(pincode));
    },
    resetPostalData: () => {
      dispatch(resetPostalData());
    },
    fetchCartItemsEDDFromClient: pincode => dispatch(fetchCartItemsEDDFromClient(pincode)),
    setDelivery: id => setDelivery(id, dispatch),
    setCheckedAddress: (id, postalCode, index, edd, isStoreAddress) => {
      dispatch(setCheckedAddress(id, postalCode, index, edd, isStoreAddress));
    },
    updateAddressOnCart: (obj) => {
      dispatch(changeAddressSelectionOnCart(obj));
    }
  };
};
export default AddAddressDesktop = connect(mapStatetoProps, mapDispatchToProps)(AddAddressDesktop);
// Abhishek's Changes
